module.exports = __webpack_public_path__ + "fonts/inter-v11-latin-300.71cb4fb.woff2";